export default __webpack_public_path__ + "static/media/hardware (1).4ccecf25.png";